import React from 'react'
import classnames from 'classnames'

const DescriptionOption = (props) =>
{
    const { title, description, active, src, alt, onClick, icon, styles } = props

    return (
        <>
            <img
                className={styles.charImgMobile}
                alt={alt}
                src={src}
            />
            <div
                className={classnames(styles.descriptionBox, { [styles.active]: active })}
                onClick={onClick}
            >
                <div className={styles.descriptionContainer}>
                    <img
                        className={styles.icon}
                        alt="HOMYHUB icon"
                        src={icon}
                    />
                    <h3 className={styles.descriptionTitle}>{title}</h3>
                    <p className={styles.descriptionText}>{description}</p>
                </div>
            </div>
        </>
    )
}

export default DescriptionOption;
